import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { toast } from 'sonner'
import { ArrowLeft, Pencil } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { PageHeader } from '@/components/shared'
import { emailTemplateService } from '@/services/emailTemplateService'
import EmailPreview from '@/components/MarketingEmail/EmailPreview'

const TemplatePreview = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data, isLoading } = useQuery(
    ['email-template-preview', id],
    () => emailTemplateService.previewTemplate(id),
    { onError: () => toast.error('Failed to render preview') }
  )
  const preview = data?.data

  return (
    <div className="space-y-6">
      <PageHeader
        title="Template Preview"
        description="Rendered with sample contact data"
        actions={
          <>
            <Button variant="outline" size="sm" onClick={() => navigate('/marketing-email/templates')}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back
            </Button>
            <Button size="sm" onClick={() => navigate(`/marketing-email/templates/${id}/edit`)}>
              <Pencil className="mr-2 h-4 w-4" />
              Edit
            </Button>
          </>
        }
      />

      {isLoading ? (
        <Skeleton className="h-96 w-full" />
      ) : (
        <EmailPreview subject={preview?.subject} previewText={preview?.previewText} html={preview?.html} />
      )}
    </div>
  )
}

export default TemplatePreview
